// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  cloverAuthUrl: 'https://sandbox.dev.clover.com/oauth/v2/authorize',
  cloverApiUrl: 'https://sandbox.dev.clover.com',
  squareAuthUrl: 'https://connect.squareupsandbox.com/oauth2/authorize',
  squarePermissions: 'ITEMS_READ+MERCHANT_PROFILE_READ+ORDERS_WRITE+ORDERS_READ+PAYMENTS_WRITE+DEVICE_CREDENTIAL_MANAGEMENT+PAYMENTS_WRITE_ADDITIONAL_RECIPIENTS+PAYMENTS_WRITE_IN_PERSON+EMPLOYEES_READ+PAYMENTS_READ+CUSTOMERS_WRITE',
  client_id: '7HPEPVBTZGDCP',
  clientSecret: '2d6e8a94-c46f-c605-ac69-728192f1afec',
  clientIdSquare: 'sandbox-sq0idb-GqEM0ljcNRXO8WKzTP9tHQ',
  docs_url: 'https://drivensoftwaresolutions.com/docs/',
  cloverConnectorAppId: 'PVZY6TBHX5JSE.7HPEPVBTZGDCP',
  // Clover Go dev-kit reader is Remote-Key-Injected against Clover SANDBOX and only
  // reaches Ready when the SDK authenticates a matching SANDBOX merchant token. In
  // production this token is minted per-merchant at boot via getCloverToken (no
  // manual step). Sandbox test merchants have no such server-side token, so the
  // dev-kit reader would never authenticate — we seed the dev merchant + a validated
  // sandbox token here so `dev` builds work out of the box. This token is SANDBOX-only
  // (401s against api.clover.com) so bundling it in the dev artifact exposes nothing
  // usable in production. It is seeded setIfBlank, so an MDM push always wins.
  // These fields are intentionally ABSENT from environment.prod.ts.
  cloverGoSandboxMerchantId: '6RD8H04A896K1',
  cloverGoSandboxToken: '504b91e5-97a9-308a-aa3e-95d303158575',
  // Dedicated Clover Go SDK API key/secret, issued separately by Clover Developer
  // Relations for the SANDBOX Go SDK — these are NOT the OAuth App ID/Secret
  // (client_id/clientSecret above). The Go SDK's GoSdkConfiguration.Builder needs
  // this distinct pair to authenticate the SDK so the dev-kit reader can complete
  // Remote Key Injection (RKI) and reach Ready. Without it the reader pairs over
  // Bluetooth and then stalls at "SDK not ready". SANDBOX-only (rejected by
  // api.clover.com), so bundling it in dev artifacts exposes nothing usable in
  // production. The PRODUCTION Go SDK pair ships via MDM managed config, never in
  // the bundle — so these fields stay ABSENT from environment.prod.ts.
  cloverGoSandboxApiKey: 'GLh1KOHtIZhFRS0aTGZGZ8gO1IRFvycQ',
  cloverGoSandboxApiSecret: 'qDKXlqrqzzaO9hrQOaWp6TqvlSceol28EoHjdn0yoz1wbLOrj7QC9mXhltVscgsY',
  // Square OAuth `state` is now generated per-attempt at the call site —
  // see src/app/_services/square-oauth.util.ts. Do NOT reintroduce a
  // hardcoded `state` value; Square QA treats a reused state as a P0
  // CSRF failure.
  //apiUrl: '/api',
  apiUrl: 'https://grubgrab.net/api',
  // apiUrl: 'http://localhost:4000/api',
  websiteSubdomainUrl: '.grubgrab.net/website',
  websitePathUrl: 'https://grubgrab.net/website',
  subdomainUrl: '.grubgrab.net',
  scanToPayUrl: 'https://www.clover.com/scan-to-pay/',
  cryptoSecret: 'CloverServer Driven Software Solutions LLC 4049969713-2d6e8a94-c46f-c605-ac69-728192f1afec',
  VAPID_PUBLIC_KEY: 'BFz1U2xd_ofkIHF3FoYX_9WPpG0N1KrcE4DavzssgyRvncfKMJaBN_6m9JEGQTlmJ873dhny0-0msHBTlLQC2Ps', // Vapid Key for Push notification
  apiServerUrl: 'https://grubgrab.net',
  base_url: '',
  // qrOrderURL: 'https://grubgrab.net/cloverAuth/cloverAuth?',
  qrOrderURL: 'http://localhost:4200/cloverAuth/cloverAuth?',
  uberAuthUrl: 'https://login.uber.com/oauth/v2/authorize',
  uberTokenUrl: 'https://login.uber.com/oauth/v2/token',
  uberApiBaseUrl: 'https://api.uber.com/v1/eats',
  uberClientId: 'CpgXhP7vUAFPGh6rEYHA9ufpOkxXWWlp',
  uberClientSecret: 'JV379e2MbE3Uu23Wmg_wkytQ5JYEZryv8cmkESkT',
  uberScopes: 'eats.store.orders',
  uberRedirectUrl: 'https://dine-n-go-dev.herokuapp.com/cloverAuth/uberAuth',
  doordashApiUrl: 'https://openapi.doordash.com',
  grubhubApiUrl: 'https://api-gtm.grubhub.com',
  grubhubAuthUrl: 'https://api-gtm.grubhub.com/oauth/authorize',
  grubhubClientId: '',
  grubhubScopes: 'orders.read orders.write',
  grubhubRedirectUrl: 'https://dine-n-go-dev.herokuapp.com/cloverAuth/grubhubAuth',
  AWS_ACCESS_KEY_ID: 'AKIAW5WU5CXZ067GFZFL',
  AWS_SECRET_ACCESS_KEY: '5uSJ1aFсsOOXtXA9jyeО4ihmgFvqO/V9eXrFS09C'
};

